import { writable, derived } from 'svelte/store';
import { get } from 'svelte/store';
export const masterData = writable();
export const getMasterData = () => {
  return get(masterData);
};
export const setMasterData = (data) => {
  masterData.set(data);
};
